import { __module as t } from "../../../_virtual/isFQDN.js";
import { a as e } from "./util/assertString.js";
import { m as r } from "./util/merge.js";
!function (t, l) {
  Object.defineProperty(l, "__esModule", {
    value: !0
  }), l.default = function (t, e) {
    (0, u.default)(t), (e = (0, a.default)(e, o)).allow_trailing_dot && "." === t[t.length - 1] && (t = t.substring(0, t.length - 1)), !0 === e.allow_wildcard && 0 === t.indexOf("*.") && (t = t.substring(2));
    var r = t.split("."),
      l = r[r.length - 1];
    return !(e.require_tld && (r.length < 2 || !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(l) || /\s/.test(l)) || !e.allow_numeric_tld && /^\d+$/.test(l)) && r.every(function (t) {
      return !(t.length > 63 || !/^[a-z_\u00a1-\uffff0-9-]+$/i.test(t) || /[\uff01-\uff5e]/.test(t) || /^-|-$/.test(t) || !e.allow_underscores && /_/.test(t));
    });
  };
  var u = s(e),
    a = s(r);
  function s(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  var o = {
    require_tld: !0,
    allow_underscores: !1,
    allow_trailing_dot: !1,
    allow_numeric_tld: !1,
    allow_wildcard: !1
  };
  t.exports = l.default, t.exports.default = l.default;
}(t, t.exports);
var l = t.exports;
export { l as i };